module.exports = __webpack_public_path__ + "static/img/020 3.d3685fce.jpg";